<template>
  <template v-if="mq.mdPlus">
    <component
      :is="component(item.tag)"
      v-for="(item, index) in article.desktop"
      :key="index"
      v-bind="item.props"
    >
      <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
        <component
          :is="element.tag"
          v-for="(element, elementIndex) in slot"
          :key="elementIndex"
        >
          {{ element.text }}
        </component>
      </template>
    </component>
  </template>

  <template v-else>
    <component
      :is="component(item.tag)"
      v-for="(item, index) in article.mobile"
      :key="index"
      v-bind="item.props"
    >
      <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
        <component
          :is="element.tag"
          v-for="(element, elementIndex) in slot"
          :key="elementIndex"
        >
          {{ element.text }}
        </component>
      </template>
    </component>
  </template>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "ArticleJson",
  inject: ["mq"],
  props: {
    articleHandle: {
      type: String,
      required: true,
    },
  },
  computed: {
    article() {
      return require(`@/content/${this.articleHandle}.json`);
    },
  },
  methods: {
    component(name) {
      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/journal/top-level/${name}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot;
    },
  },
};
</script>
